import React from "react";
import { Button, Grid, Modal, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
// import ThreeOptionVerticalSwitch from '../slider/ThreeOptionVerticalSwitch';
import styles from "./styles";
import "animate.css/animate.css";
import slideTutorial from "../../images/slider-animation.gif";

const DescriptionModal = ({
  classes,
  hideModal,
  open,
  answeredCorrectly,
}) => {
  return (
    <Modal open={open} onClick={() => hideModal()}>
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Grid className={`${classes.evaluatorModalContainer}`}>
          <Grid container className={classes.evalInnerModal}>
            <Grid style={{ width: "80%", display: 'flex', flexDirection: "column", justifyContent: "center" }}>
              <Typography className={classes.evalDescHeading}>
              The Fed has several channels to influence the economy. This interactive examines the interest rate channel.
              </Typography>
              <Typography
                className={classes.evalDesc}
                style={{ padding: "10px 0px" }}
              >
              In each scenario, identify what action a central bank would do with their interest rate on reserve balances (the primary rate that affects short-term market rates).
              </Typography>
            </Grid>
            <Grid style={{  display: "flex", width: "20%", justifyContent: "right" }}>
              <img
                alt=""
                src={slideTutorial}
                className={classes.correctIncorrectIcon}
              />
            </Grid>
            {/* <ThreeOptionVerticalSwitch
                  selected={0}
                  index={3}
                >
            </ThreeOptionVerticalSwitch> */}
          </Grid>
          <Grid container justify="center">
            <Button
              className={classes.submitButton}
              // onClick={() => nextQuestion()}
            >
              GOT IT
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default withStyles(styles)(DescriptionModal);
